import {setCookie} from './set-cookie';

export function deleteCookie(cName: string) {
  setCookie(cName, '', 0);
}
